import { TimeFormat } from "../types/calendarSettings";

class timestampService {
  static returnTwoDigitTimeString(timeValue: number) {
    if (timeValue < 10) {
      return `0${timeValue}`;
    } else {
      return timeValue.toString();
    }
  }

  static getHoursAndMinutesTimestamp(date: string | Date): string {
    return new Date(date).toLocaleTimeString([], {
      hour12: false,
      hour: "2-digit",
      minute: "2-digit",
    });
  }

  static getRoundedDate(date: Date) {
    let minutes = date.getMinutes();
    let hours = date.getHours();

    if (minutes < 15) date.setMinutes(0);
    else if (minutes < 45) date.setMinutes(30);
    else {
      date.setMinutes(0);
      date.setHours(hours + 1);
    }

    return date;
  }

  static timeToMinutes(time: TimeFormat | string) {
    if (!time || time === "None") return "00:00"
    return time.slice(0, 5)
  }

  static timeToSeconds(time: string) {
    const newTime = time.trim();
    if (!newTime) return "None";
    return (newTime.length === 5 ? `${newTime}:00` : newTime) as TimeFormat;
  }

  static timeToMinutesSum = (time: string): number => {
    const hhmm = time.includes("T")
      ? timestampService.getHoursAndMinutesTimestamp(time) : time

    const [hours, minutes] = hhmm.split(":").map(Number);
    return hours * 60 + minutes;
  };

  static mergeTimeIntoDate(originalDateTime: string, newTime: string): string {
    if (!originalDateTime || !newTime || newTime === "None") return originalDateTime;

    const [date] = originalDateTime.split("T");
    const [hours, minutes] = newTime.split(":").map(Number);

    const localDate = new Date(`${date}T00:00:00`);
    localDate.setHours(hours, minutes, 0, 0);
    return localDate.toISOString().slice(0, 16) + "Z";
  }
}


export default timestampService;
